import { Component, OnInit } from '@angular/core';
import { ClassService } from './class.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { Severity, Status, Answer } from '../../constants/constants';
import { ObjectNames } from '../../constants/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { FinanceSetupService } from '../finance-setup.service';

@Component({
  selector: 'app-class',
  templateUrl: './class.component.html',
  styleUrls: ['./class.component.scss']
})
export class ClassComponent implements OnInit {

  classForm: FormGroup;
  allClasses = [];
  expandedRowsClass: {} = {};
  associatedProducts: string;
  displayClassAvailability: boolean = false;
  answertypeConstants = Answer;
  statusConstants = Status;
  classConstants = ObjectNames;
  addEditClassHeader: string;
  displayAddEditClass: boolean = false;
  classTypes=[];
  disabledParent: boolean=false;
  isAddClass: boolean=false;
  childType: boolean=false;
  filteredParent=[];
  disabledStatus: boolean=false;

  constructor(private classService: ClassService, private confirmationService: ConfirmationService,
    private messageService: MessageService, private titlecasePipe: TitleCasePipe,
    private fb: FormBuilder,private app: AppMainComponent,private financeService: FinanceSetupService) { }

  ngOnInit(): void {
    this.financeService.getClass().subscribe(classes => {
      if (classes) {
        this.showAddClass();
      }
    })
    this.classForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      parentId: [''],
      statusId: [Status.ACTIVE],
      status: [null]
    });
    this.loadClassList();
  }

  loadClassList() {
    this.classService.getAllClasses().subscribe((classes) => {
      this.allClasses = classes;
      const thisRef = this;
      this.allClasses.forEach(element => {
        thisRef.expandedRowsClass[element.id] = true;
      });
      this.expandedRowsClass = Object.assign({}, this.expandedRowsClass);

      let data = [];
      for (let children of classes) {

        let ChildData = [];
        for (let sub of children.childClass) {
          sub.toggle = true;
          sub.subExpanded = true;

          if(sub.statusId==Status.ACTIVE){
            let eachSub = {
              label: sub.name,
              value: sub.id,
              children: []
            }
            ChildData.push(eachSub)
          }
        }

        if(children.statusId==Status.ACTIVE){
          let eachData = {
            label: children.name,
            value: children.id,
            children: ChildData
          }
          data.push(eachData)
        }
      }
      this.classTypes = data;
    })
  }

  checkClass(parent, type, child?, subChild?) {
    const deleteId = (type == ObjectNames.parentType ? parent.id : type == ObjectNames.childType ? child.id : subChild.id);
    this.classService.checkClass(deleteId).subscribe((check) => {
      if (check.item1) {
        this.displayClassAvailability = true;
        this.associatedProducts = check.item2;
      } else {
        this.deleteClass(parent, type, child, subChild);
      }
    })
  }

  deleteClass(parent, type, child?, subChild?) {
    const deleteId = (type == ObjectNames.parentType ? parent.id : type == ObjectNames.childType ? child.id : subChild.id);
    this.confirmationService.confirm({
      message: 'Do you want to delete this Class?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.classService.deleteClass(deleteId).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          if (type == ObjectNames.parentType) {
            const index = this.allClasses.indexOf(parent);
            this.allClasses.splice(index, 1);
          } else if (type == ObjectNames.childType) {
            const index = parent.childClass.indexOf(child);
            parent.childClass.splice(index, 1);
          } else {
            const index = child.childClass.indexOf(subChild);
            child.childClass.splice(index, 1);
          }
          this.loadClassList();
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  showAddClass(){
    this.classForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      parentId: [''],
      statusId: [Status.ACTIVE],
      status: [null]
    });
    this.isAddClass=true;
    this.displayAddEditClass=true;
    this.disabledStatus=false;
  }

  showEditClass(parent, type, child?, subChild?) {
    this.addEditClassHeader = ObjectNames.EidtClassTitle;
    this.displayAddEditClass = true;
    this.isAddClass=false;
    if (type == ObjectNames.parentType) {
      this.classForm.patchValue(parent);
      this.classForm.controls['statusId'].setValue(parent.statusId == Status.ACTIVE ? true : false);
      this.disabledParent = true;
      this.childType=false;
      this.disabledStatus=false;
    } else if (type == ObjectNames.childType) {
      this.classForm.patchValue(child);
      this.classForm.controls['statusId'].setValue(child.statusId == Status.ACTIVE ? true : false);
      const filteredParent = this.allClasses.filter(type=> type.id==child.parentId)[0];
      this.classForm.controls['parentId'].setValue(filteredParent);
      this.disabledParent = true;
      this.childType=false;
      if(parent.statusId==Status.INACTIVE){
        this.disabledStatus=true;
      }else{
        this.disabledStatus=false;
      }
    }else{
      this.classForm.patchValue(subChild);
      this.childType=true;
      this.classForm.controls['statusId'].setValue(subChild.statusId == Status.ACTIVE ? true : false);
      this.filteredParent = parent.childClass;
      const filteredParent = parent.childClass.filter(type=> type.id==subChild.parentId)[0];
      this.classForm.controls['parentId'].setValue(filteredParent);
      this.disabledParent = true;
      if(child.statusId==Status.INACTIVE){
        this.disabledStatus=true;
      }else{
        this.disabledStatus=false; 
      }
    }

  }

  checkClassProduct() {
    if (this.classForm.controls['statusId'].value == false) {
      this.classService.checkClass(this.classForm.controls['id'].value).subscribe(check => {
        if (check.item1) {
          this.displayClassAvailability = true;
          this.associatedProducts = check.item2;
          this.classForm.get("statusId").setValue(true);
        } else {
          return;
        }
      })
    }
  }

  save(value) {
    value.statusId = (value.statusId==true?Status.ACTIVE:Status.INACTIVE);
    //g(value);
    if(this.isAddClass){
      this.addClass(value);
    }else{
      this.updateClass(value);
    }
  }

  addClass(value){
    value.parentId = (value.parentId?value.parentId.value:0);
    this.classService.addClass(value).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Class Added successfully...' });
      this.loadClassList();
      this.displayAddEditClass = false;
    }).catch(() => {
      this.displayAddEditClass = false;
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  updateClass(value){
    value.parentId = (value.parentId?value.parentId.id:0);
    value.updatedBy = this.app.userId;
    value.updatedDate = new Date().toISOString();
    value.updatedSource = this.app.userIP;

    this.classService.updateClass(value).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Class Updated successfully...' });
      this.loadClassList();
      this.displayAddEditClass = false;
    }).catch(() => {
      this.displayAddEditClass = false;
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

}
